<template>
  <div class="main-container">
    <router-view />
  </div>
</template>
